/**
 * Other events for GTM
 */
class MM_GTMEvents {
    constructor() {
        this.goToCheckout();
        this.addToCartFromList();
        this.addToCartFromProduct();
        this.productLinks();
        this.variableProductLinks();
        this.removeFromCart();
        this.updatedCartEvents();
    }

    goToCheckout () {
        if (!$('.wc-proceed-to-checkout').length) {
            return;
        }

        $('.woocommerce').on('click', (e) => {
            if (e.target.tagName === 'A' && e.target.classList.contains('checkout-button')) {
                e.preventDefault();

                dataLayer.push({     
                    'event': 'checkoutOption', 
                    'ecommerce': { 
                        'checkout_option': { 
                            'actionField': {
                                'step': 2, 
                                'option': 'Dane klienta'
                            } 
                        } 
                    },
                    'eventCallback': function () {
                        document.location = $(e.target).attr('href');
                    }
                });
            }
        });
    }

    addToCartFromList () {
        let self = this;

        if (!$('a.product_type_simple.add_to_cart_button').length) {
            return;
        }

        $('a.product_type_simple.add_to_cart_button:not(.yith-variable-product-button)').each((i, btn) => {
            $(btn).on('click', function () {
                let productCategory = '';
                let categoryContent = $(this).parent().find('.product-category');

                if (categoryContent.length) {
                    productCategory = categoryContent.eq(0).text();
                }

                let productPrice = '';
                let priceContent = $(this).parent().find('.woocommerce-Price-amount');
                
                if (priceContent.length) {
                    productPrice = Number(parseFloat(priceContent.text().replace(',', '.'))).toFixed(2);
                }

                let productName = '';
                let nameContent = $(this).parent().find('.woocommerce-loop-product__title');

                if (nameContent.length) {
                    productName = nameContent.text();
                }

                let productID = $(this).attr('data-product_sku');
                let productDataToUse = { 	 
                    'name': productName,
                    'id': $(this).attr('data-product_sku'),
                    'price': productPrice,
                    'category': productCategory,
                    'quantity': parseInt($(this).attr('data-quantity'), 10)
                };

                if (window.mm_visible_products_list) {
                    let productData = window.mm_visible_products_list.filter(prod => prod.id === productID);

                    if (productData.length) {
                        productDataToUse = productData[0];
                        productDataToUse.quantity = parseInt($(this).attr('data-quantity'), 10);
                    }
                }

                dataLayer.push({ 
                    'event': 'addToCart', 
                    'pageType': self.getPageType(),
                    'languageVersion': 'PL', 
                    'ecommerce': { 
                        'currencyCode': 'PLN',
                        'add': { 	 
                            'products': [
                                productDataToUse
                            ] 
                        } 
                    } 
                });
            });
        });

        $('#yith-wacp-popup').on('click', e => {
            if ($(e.target).hasClass('go-cart')) {
                if (!window.mm_visible_products_list || !window.mm_visible_products_list.length) {
                    return;
                }

                let variantValue = $('#yith-variable-products-variation-id').val();
                let variantOption = $('#yith-variable-products-variation-id').find('option[value="' + variantValue + '"]');
                let variantText = variantOption.text();
                let productID = $(e.target).attr('onclick');

                if (!!variantText && !!productID) {
                    variantText = variantText.split(';');
                    let productPrice = variantText[1];
                    variantText = variantText[0];
                    productID = productID.split('(');

                    if (productPrice) {
                        productPrice = productPrice.replace(',', '.');
                        productPrice = productPrice.replace(/[^0-9\.]/gmi, '');
                        productPrice = Number(parseFloat(productPrice)).toFixed(2);
                    }

                    if (productID.length > 1) {
                        productID = productID[1].replace(')', '');
                        productID = parseInt(productID, 10);
                        let productSKU = window.mm_visible_products_id_sku_map[productID];
                        let productData = window.mm_visible_products_list.filter(prod => prod.id === productSKU);
        
                        if (productData.length) {
                            let productDataToUse = productData[0];
                            productDataToUse.quantity = 1;
                            productDataToUse.variant = variantText;
                            productDataToUse.dimension9 = variantText;
                            productDataToUse.price = productPrice;

                            dataLayer.push({ 
                                'event': 'addToCart', 
                                'pageType': self.getPageType(),
                                'languageVersion': 'PL', 
                                'ecommerce': { 
                                    'currencyCode': 'PLN',
                                    'add': { 	 
                                        'products': [
                                            productDataToUse
                                        ] 
                                    } 
                                } 
                            });
                        }
                    }
                }
            }
        });
    }

    addToCartFromProduct () {
        let self = this;

        if (!$('body.single-product .single_add_to_cart_button').length) {
            return;
        }

        $('body.single-product .single_add_to_cart_button').each((i, btn) => {
            $(btn).on('click', function (e) {
                if ($(btn).hasClass('disabled')) {
                    return false;
                }

                if ($(btn).attr('data-clicked') !== 'true') {
                    $(btn).attr('data-clicked', 'true');

                    let detectedVariant = false;
                    let detectedDimension9 = false;

                    if ($('.woovr-variation-selector').length) {
                        if ($('.woovr-variation-selector input[type="radio"]:checked').length) {
                            let labelName = $('.woovr-variation-selector input[type="radio"]:checked').eq(0).parent().parent().find('.woovr-variation-name');
                            
                            if (labelName.length) {
                                detectedVariant = labelName.eq(0).text().replace(',', '.');
                                detectedDimension9 = detectedVariant;
                            }
                        }
                    }

                    if (!detectedVariant) {
                        detectedVariant = window.mm_single_product_data.variant;
                    }

                    if (!detectedDimension9) {
                        detectedDimension9 = window.mm_single_product_data.dimension9;
                    }

                    dataLayer.push({ 
                        'event': 'addToCart', 
                        'pageType': self.getPageType(),
                        'languageVersion': 'PL', 
                        'ecommerce': { 
                            'currencyCode': 'PLN',
                            'add': { 	 
                                'products': [{ 	 
                                    'name': window.mm_single_product_data.name,
                                    'id': window.mm_single_product_data.id,
                                    'price': window.mm_single_product_data.price,
                                    'brand': window.mm_single_product_data.brand,
                                    'category': window.mm_single_product_data.category,
                                    'quantity': parseInt($('.quantity input[name="quantity"]').eq(0).val(), 10),
                                    'variant': detectedVariant,
                                    'typ': window.mm_single_product_data.typ,
                                    'dimension9': detectedDimension9
                                }] 
                            } 
                        }
                    });   
                }
            });
        });
    }

    removeFromCart () {
        let self = this;

        if (!$('.woocommerce-cart .woocommerce-cart-form .product-remove').length) {
            return;
        }

        $('.woocommerce-cart .woocommerce').on('click', (e) => {
            if (!(e.target.tagName === 'A' && e.target.classList.contains('remove') && e.target.parentNode.classList.contains('product-remove'))) {
                return;
            }

            let productPrice = '';
            let priceContent = $(e.target).parent().parent().find('.woocommerce-Price-amount');
            
            if (priceContent.length) {
                productPrice = Number(parseFloat(priceContent.text().replace(',', '.'))).toFixed(2);
            }

            let productName = '';
            let nameContent = $(e.target).parent().parent().find('.product-name > a');

            if (nameContent.length) {
                productName = nameContent.text();
            }

            dataLayer.push({ 
                'event': 'removeFromCart', 
                'pageType': self.getPageType(),
                'languageVersion': 'PL', 
                'ecommerce': { 
                    'currencyCode': 'PLN',
                    'remove': { 	 
                        'products': [{ 	 
                            'name': productName,
                            'id': $(e.target).attr('data-product_sku'),
                            'price': productPrice,
                            'quantity': parseInt($(e.target).parent().parent().find('.quantity input').eq(0).val(), 10)
                        }] 
                    } 
                }
            });  
            
            window.mm_items_in_cart = window.mm_items_in_cart.filter(prod => !(prod.name === productName && prod.id === $(e.target).attr('data-product_sku'))).slice();
        });
    }

    productLinks () {
        let self = this;

        if (!$('.woocommerce-LoopProduct-link').length) {
            return;
        }

        $('.woocommerce-LoopProduct-link').each((i, link) => {
            $(link).on('click', function (e) {
                e.preventDefault();

                let productCategory = '';
                let categoryContent = $(this).find('.product-category');

                if (categoryContent.length) {
                    productCategory = categoryContent.eq(0).text();
                }

                let productPrice = '';
                let priceContent = $(this).find('.woocommerce-Price-amount');
                
                if (priceContent.length) {
                    productPrice = Number(parseFloat(priceContent.text().replace(',', '.'))).toFixed(2);
                }

                let productName = '';
                let nameContent = $(this).find('.woocommerce-loop-product__title');

                if (nameContent.length) {
                    productName = nameContent.text();
                }

                let productID = $(this).parent().find('a[data-product_sku]').attr('data-product_sku');
                let productDataToUse = { 	 
                    'name': productName,
                    'id': $(this).parent().find('a[data-product_sku]').attr('data-product_sku'),
                    'price': productPrice,
                    'category': productCategory
                };

                if (window.mm_visible_products_list) {
                    let productData = window.mm_visible_products_list.filter(prod => prod.id === productID);

                    if (productData.length) {
                        productDataToUse = productData[0];
                    }
                }

                dataLayer.push({ 
                    'event': 'productClick',  
                    'pageType': self.getPageType(),
                    'languageVersion': 'PL', 
                    'ecommerce': { 
                        'currencyCode': 'PLN',
                        'click': { 
                            'actionField': {
                                'list': self.getListName()
                            },                          
                            'products': [
                                productDataToUse
                            ] 
                        } 
                    },
                    'eventCallback': function () {
                        document.location = $(link).attr('href');
                    }
                });
            });
        });
    }

    variableProductLinks () {
        let self = this;

        if (!$('.product_type_simple:not(.add_to_cart_button), .product_type_variable.add_to_cart_button').length) {
            return;
        }

        $('.product_type_simple:not(.add_to_cart_button), .product_type_variable.add_to_cart_button').each((i, link) => {
            $(link).on('click', function (e) {
                e.preventDefault();

                let productCategory = '';
                let categoryContent = $(this).parent().find('.product-category');

                if (categoryContent.length) {
                    productCategory = categoryContent.eq(0).text();
                }

                let productPrice = '';
                let priceContent = $(this).parent().find('.woocommerce-Price-amount');
                
                if (priceContent.length) {
                    productPrice = Number(parseFloat(priceContent.text().replace(',', '.'))).toFixed(2);
                }

                let productName = '';
                let nameContent = $(this).parent().find('.woocommerce-loop-product__title');

                if (nameContent.length) {
                    productName = nameContent.text();
                }

                let productID = $(this).attr('data-product_sku');
                let productDataToUse = { 	 
                    'name': productName,
                    'id': $(this).attr('data-product_sku'),
                    'price': productPrice,
                    'category': productCategory,
                    'quantity': parseInt($(this).attr('data-quantity'), 10)
                };

                if (window.mm_visible_products_list) {
                    let productData = window.mm_visible_products_list.filter(prod => prod.id === productID);

                    if (productData.length) {
                        productDataToUse = productData[0];
                    }
                }

                dataLayer.push({ 
                    'event': 'productClick',
                    'pageType': self.getPageType(),
                    'languageVersion': 'PL', 
                    'ecommerce': { 
                        'currencyCode': 'PLN',
                        'click': { 
                            'actionField': {
                                'list': self.getListName()
                            },	 
                            'products': [
                                productDataToUse
                            ] 
                        } 
                    },
                    'eventCallback': function () {
                        document.location = $(link).attr('href');
                    }
                });
            });
        });
    }

    getPageType () {
        let pageType = '';

        if ($('body').hasClass('search-results')) {
            pageType = 'search';
        } else if ($('body').hasClass('home')) {
            pageType = 'home';
        } else if ($('body').hasClass('single-product')) {
            pageType = 'product';
        } else if ($('body').hasClass('woocommerce-cart')) {
            pageType = 'basket';
        } else if ($('body').hasClass('archive')) {
            pageType = 'category';
        }

        return pageType;
    }

    getListName () {
        let listName = '';

        if ($('body').hasClass('search-results')) {
            listName = 'Wyniki wyszukiwania';
        } else if ($('body').hasClass('home')) {
            listName = 'Strona główna';
        } else if ($('body').hasClass('single-product')) {
            listName = 'Powiązane produkty';
        } else if ($('body').hasClass('woocommerce-cart')) {
            listName = 'Inni klienci kupili również';
        } else if ($('body').hasClass('archive')) {
            listName = 'Lista produktów w kategorii';
        }

        return listName;
    }

    updatedCartEvents () {
        let self = this;

        if (!$('.woocommerce-cart .woocommerce-cart-form button[name="update_cart"]').length) {
            return;
        }

        $(document.body).on('updated_wc_div', function() {
            let products = window.mm_items_in_cart.slice();
            let removedProducts = [];
            let cartForm = $('.woocommerce-cart-form');

            for (let i = 0; i < products.length; i++) {
                let removeLink = cartForm.find('a.remove[data-product_sku="' + products[i].id + '"]');
                
                if (removeLink.length) {
                    let originalQuantity = products[i].quantity;
                    products[i].quantity = parseInt(removeLink.parents('.woocommerce-cart-form__cart-item').find('.qty').val(), 10);
                } else {
                    removedProducts.push(JSON.parse(JSON.stringify(products[i])));
                }
            }

            if (removedProducts.length) {
                removedProducts = removedProducts.map(removedProduct => {
                    return {
                        'name': removedProduct.name,
                        'id': removedProduct.id,
                        'price': removedProduct.price,
                        'quantity': removedProduct.quantity
                    }
                });

                for (let i = 0; i < removedProducts.length; i++ ) {
                    products = products.filter(prod => !(prod.name === removedProducts[i].name && prod.id === removedProducts[i].id)).slice();
                }

                window.mm_items_in_cart = products.slice();

                dataLayer.push({ 
                    'event': 'removeFromCart', 
                    'pageType': self.getPageType(),
                    'languageVersion': 'PL', 
                    'ecommerce': { 
                        'currencyCode': 'PLN',
                        'remove': { 	 
                            'products': removedProducts
                        } 
                    }
                });
            }

            dataLayer.push({
                'pageType': 'cart', 
                'languageVersion': 'PL', 
                'ecommerce': { 
                    'currencyCode': 'PLN', 
                    'checkout': { 
                        'actionField': { 
                            'step': 1, 
                            'option': 'cart', 
                            'action': 'checkout' 
                        }, 
                        'products': window.mm_items_in_cart.slice()
                    }
                } 
            });
        });
    }
}